module.exports = __webpack_public_path__ + "static/media/food-placeholder-2.c0960943.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/food-placeholder-2.png
// module id = 1115
// module chunks = 0